<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <CaseACocherLive code="decla1" v-model="sasReconnaissanceArm.declaration1" :live="liveSasReconnaissanceArm(9003)" />
      <CaseACocherLive code="decla2" v-model="sasReconnaissanceArm.declaration2" :live="liveSasReconnaissanceArm(9004)" />
      <CaseACocherLive code="decla3" v-model="sasReconnaissanceArm.declaration3" :live="liveSasReconnaissanceArm(9005)" />
      <CaseACocherLive code="decla4" v-model="sasReconnaissanceArm.declaration4" :live="liveSasReconnaissanceArm(9006)" />
      <CaseACocherLive code="decla5" v-model="sasReconnaissanceArm.declaration5" :live="liveSasReconnaissanceArm(9007)" />
    </v-form>
  </div>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
export default {
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasReconnaissanceArm() {
      return this.sas.sasReconnaissanceArmFranceQuebec
    }
  },
  methods: {
    liveSasReconnaissanceArm(cle) {
      return { endpoint: "sas-reconnaissance-arm-france-quebec", cle: cle, fileId: this.sasReconnaissanceArm.id }
    }
  }
}
</script>

<style></style>
